import 'rxjs/add/observable/fromEvent';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { I18nService } from '../core/services/i18n.service';
import { ProfileService } from '../shared/service/profile.service';
import { WebsocketService } from 'src/app/shared/service/websocket.service';
import { ToastrService } from 'ngx-toastr';
import { MESSAGE_TOAST } from 'src/app/shared/enums/message-toast-enum';

@Component({
  selector: 'app-root',
  template: `
      <router-outlet></router-outlet>
      <!-- Live Chat Coming Soon -->
      <!-- <div class="bold360 bold360-green" id="contact-us"> -->
      <!-- <div class="bold360-button-contact" style="text-align: center !important;top: 17px !important;left: 0px !important;">Live Chat Coming Soon</div> -->
      <!-- Spinner -->
      <app-spinner class="justify-content-center align-items-center undisplayed"></app-spinner>
  `,
  styles: [
    `
    `
  ]
})
export class AppComponent implements OnInit, OnDestroy {
  loading = false;
  websocketSubscription: Subscription;

  constructor(
    private i18n: I18nService,
    private toast: ToastrService,
    private profileService: ProfileService,
    private websocket: WebsocketService
  ) {
    // Setup i18N config
    this.i18n.init();
  }

  ngOnInit() {
    // let boldObj = document.getElementsByClassName('bcFloat')[0];
    // let boldObjInterval = setInterval(() => {
    //   if (boldObj) {
    //     const boldButton = boldObj.getElementsByTagName('a')[0];
    //     const boldButtonStyle = `<div class="bold360 bold360-green" id="contact-us">
    //                                 <i class="bold360-button-icon fa fa-comments-o"></i>
    //                                 <div class="bold360-button-contact">Contact Us</div>
    //                              </div>`;
    //     boldButton.innerHTML = boldButton.innerHTML.concat('', boldButtonStyle);

    //     const contactUs = document.getElementById('contact-us');
    //     const buttonStream$ = contactUs.addEventListener('click', () => {
    //       this.contactUs();
    //     });

    //     clearInterval(boldObjInterval);
    //   } else {
    //     boldObj = document.getElementsByClassName('bcFloat')[0];
    //   }
    // }, 100);

    setTimeout(() => {
      if (this.websocketSubscription) {
        this.websocketSubscription.unsubscribe();
      }
      this.subscribeWebsocket();
    }, 500);

  }

  ngOnDestroy() {
    if (this.websocketSubscription) {
      this.websocketSubscription.unsubscribe();
    }
  }

  contactUs() {
    this.getElementBold();
  }

  getElementBold() {
    let boldButtonMinimize = document.getElementsByClassName('bc-headbtn-minimize')[0];
    let boldButtonMinimizeInterval = setInterval(() => {
      if (boldButtonMinimize) {
        boldButtonMinimize.addEventListener('click', () => {
          const boldButtonMinimizeStyle = `<i class="bold360-button-icon-open fa fa-angle-double-up"></i><div class="bold360-button-open">Open</div>`;
          document.getElementsByClassName('bc-minimize-state-idle')[0].innerHTML = boldButtonMinimizeStyle;
        });

        clearInterval(boldButtonMinimizeInterval);
      } else {
        boldButtonMinimize = document.getElementsByClassName('bc-headbtn-minimize')[0];
      }
    }, 100);
  }

  subscribeWebsocket() {
    if (this.websocket.connected) {
      this.profileService.getProfileUser().subscribe((res: any) => {
        if (res && res.data && res.data.sso) {
          this.websocketSubscription = this.websocket.stompClient.subscribe(`/topic/sso/` + res.data.sso, payload => {
            if (payload && payload.body) {
              const message = JSON.parse(payload.body);
              if (message.type === 'LOGOUT') {
                this.toast.error(MESSAGE_TOAST.ERROR_SESSION_TIME_OUT);
                setTimeout(() => {
                  window.location.href = '/logout';
                }, 3000);
              }
            }
          });
          console.warn('%c subscribe succeeded ', 'background: #222; color: #bada55');
        }
      });
    } else {
      this.websocket.connect().then(this.subscribeWebsocket.bind(this));
    }
  }

}
